import { Injectable } from '@angular/core';
import { CurrentService } from './current.service';
import { CustomerService } from './customer.service';
import { environment } from '../../environments/environment';

@Injectable()
export class GTM {
  public persistantCustomData: any = [];
  private tracking: boolean;
  private trackLog: boolean;

  constructor(
    private readonly current: CurrentService,
    private readonly customer: CustomerService
  ) {}

  public init(trackingEnv: boolean) {
    this.tracking = trackingEnv;
    this.trackLog = !trackingEnv;
  }

  public get dataLayer(): any {
    return (<any>window).dataLayer;
  }

  /**
   * Création d'un VPV
   * @param pageUrl
   * @param pageTitle
   * @param customDatas
   */
  public trackPage(pageUrl: string, pageTitle: string, customDatas?: any) {
    let layerData: any = {
      event: 'VPV',
    };

    layerData.pageName = pageUrl;
    layerData.pageTitle = pageTitle;
    layerData.userId = environment.vendor ? this.current?.vendor?.sapId : this.customer?.userDatas?.id;

    this.buildTrackObj(layerData, customDatas, false);
  }

  public trackEvent(eventName: string, customDatas?: any) {
    let layerData: any = {
      event: eventName,
      userId: environment.vendor ? this.current?.vendor?.sapId : this.customer?.userDatas?.id,
    };

    this.buildTrackObj(layerData, customDatas);
  }

  /** Log des VPV et Event pour debug */
  private _logLayerDataPush(layerData) {
    console.log('#######  DATALAYER #######');
    console.table(layerData);
  }

  /**
   * Création d'une VPV ou d'un event tracké
   * @param layerData
   * @param customDatas
   * @param usePersistantData
   */
  private buildTrackObj(layerData: any, customDatas?: any, usePersistantData: boolean = true) {
    if (usePersistantData) {
      for (const key in this.persistantCustomData) layerData[key] = this.persistantCustomData[key];
    }

    if (customDatas) {
      for (const key in customDatas) layerData[key] = customDatas[key]?.toString();
    }

    if (this.trackLog) this._logLayerDataPush(layerData);

    if (this.tracking) {
      this.dataLayer.push(layerData);
    }
  }
}
